<template>
  <div class="container" :class="UI.isMobile ? '' : 'margin-top'">
    <el-row :gutter="30">
      <el-col
        :sm="24"
        :md="UI.isMobile ? 24 : 16"
        style="transition:all .5s ease-out;margin-bottom:30px;"
      >
        <div
          class="bg-white radius-10 min-body-height"
          style="padding: 0 1%; width: 100%; margin-bottom: 0;"
        >
          <!-- <div class="flex justify-center align-center">
            <h3>{{ title }}</h3>
          </div> -->
          <div class="my-parse-content ql-editor" v-html="content"></div>
        </div>
      </el-col>
      <el-col :sm="24" :md="8" v-if="!UI.isMobile">
        <div
          style="margin-left: 5%; padding-top: 1%"
          class="bg-white radius-10 padding"
        >
          <h3 class="text-center">{{ cateStr }}</h3>
          <div
            class="flex justify-between margin-top-xs cursor-pointer"
            v-for="(item, index) in rightList"
            @click="toNews(item.id)"
            :key="index"
          >
            <div class="auto-wrap">{{ item.title }}</div>
            <div style="min-width: 120px; text-align: right;">
              {{ item.c_time.substring(0, 10) }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getNoticeById, getNoticesList } from '@/servers/homepage.js';
import { getGameById, getGamesList } from '@/servers/games.js';
import { mapState } from 'vuex';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  data() {
    return {
      title: '',
      content: '',
      rightList: [],
      cateStr: '',
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  watch: {
    $route: 'routeChange',
  },

  created() {
    this.routeChange();
  },

  methods: {
    toNews: function(newsId) {
      this.$router.replace({
        name: 'news',
        query: { id: newsId, cate: this.$route.query.cate },
      });
    },

    routeChange: function() {
      let cate = this.$route.query.cate;
      let newsId = this.$route.query.id;
      let that = this;
      switch (cate) {
        case 'notice':
          that.cateStr = '最近通知';
          getNoticeById(newsId, function(res) {
            that.title = res.title;
            that.content = res.desc;
          });
          getNoticesList({}, function(res) {
            that.rightList = res.items;
          });
          break;
        case 'games':
          that.cateStr = '最近赛事';
          getGameById(newsId, {'desc': 'desc'}, function(res) {
            that.title = res.title;
            that.content = res.desc;
          });
          getGamesList({}, function(res) {
            that.rightList = res.items;
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.my-parse-content {
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue